
import { createContext, useEffect, useState } from "react";

const loadSelectedCourse = () => {
  try {
    const savedCourse = sessionStorage.getItem("selectedCourse");
    return savedCourse ? JSON.parse(savedCourse) : { courseName: "", courseId: "" };
  } catch {
    return { courseName: "", courseId: "" };
  }
};

export const CourseContext = createContext();

export const CourseProvider = ({ children }) => {
  const [selectedCourse, setSelectedCourse] = useState(loadSelectedCourse);
  const [isCourseRegister,setIsCourseRegister]=useState(false)
  const [mentorAvailability, setMentorAvailability] = useState(null);
  const [availabilityId, setAvailabilityId] = useState(null);
  const [userDetails, setuserDetails] = useState(null);
  const [selectedDashBoardCourse, setselectedDashBoardCourse] = useState({
    courseName: "",
    courseId: "",
    user_id:""
  });

  useEffect(() => {
    if (selectedCourse?.courseId || selectedCourse?.courseName) {
      sessionStorage.setItem("selectedCourse", JSON.stringify(selectedCourse));
    } else {
      sessionStorage.removeItem("selectedCourse");
    }
  }, [selectedCourse]);

  return (
    <CourseContext.Provider value={{ selectedCourse, setSelectedCourse,isCourseRegister,setIsCourseRegister,mentorAvailability,
      setMentorAvailability,  availabilityId, setAvailabilityId,userDetails, setuserDetails,selectedDashBoardCourse, setselectedDashBoardCourse}}>
      {children}
    </CourseContext.Provider>
  );
};
